import React, { FC, useCallback, useMemo } from "react";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { useGetExperiments } from "../../behaviors/useGetExperiments";
import { useStaticInfo } from "../../hooks/useStaticInfo";
import { I18nMessages } from "../../i18n/i18n";
import { useTrackEmptyState } from "../../tracking/useTrackEmptyState";
import { EmptyStateBanner } from "../emptyStateBanner/EmptyStateBanner";

interface UpdateYourProfileBannerProps {
  readonly onBackToStyleProfile: () => void;
}

const UpdateYourProfileBanner: FC<UpdateYourProfileBannerProps> = ({ onBackToStyleProfile }) => {
  const {
    cdnPath,
    session: {
      user: { country, segment, id: userId },
    },
    tradename,
  } = useStaticInfo();
  const { experiments } = useGetExperiments();

  const trackEmptyState = useTrackEmptyState({
    country,
    segment,
    userId,
    tradename,
  });

  const imageUrl = useMemo(
    () =>
      tradename === Tradename.OUTFITTERY
        ? `${cdnPath}/images/shop/empty-states/update-profile/${segment}/${country}.webp`
        : `${cdnPath}/images/shop/empty-states/update-profile/${segment}.webp`,
    [tradename, cdnPath, segment, country],
  );

  const onLayout = useCallback(() => {
    trackEmptyState({
      type: "UpdateYourProfile",
      experiments,
    });
  }, [trackEmptyState, experiments]);

  return (
    <EmptyStateBanner
      cta={I18nMessages.UPDATE_YOUR_PROFILE_CTA}
      imageUrl={imageUrl}
      subtitle={I18nMessages.UPDATE_YOUR_PROFILE_SUBTITLE}
      title={I18nMessages.UPDATE_YOUR_PROFILE_TITLE}
      onLayout={onLayout}
      onPress={onBackToStyleProfile}
    />
  );
};

export { UpdateYourProfileBanner };
